import { type StringArrayDictionary } from "../MemberBreadcrumbs.types";

interface ActionParams {
  rid: number;
}

var currentPath = "";
var pcmNumber = "";

const capitalize = (word: string): string => {
  const splitWord = word.split("");
  splitWord[0] = splitWord[0].toUpperCase();
  const capWord = splitWord.join("");
  return capWord;
};

const transformName = [
  "technicalqueries",
  "protectionprofiles",
  "virtualteams",
  "pcm",
  "ccp",
  "nist",
  "faqs",
  "assurancemaintenance",
  "niap",
  "ecr-comments",
];

const transforms: StringArrayDictionary = {
  technicalqueries: ["technical ", "queries"],
  protectionprofiles: ["protection ", "profiles"],
  virtualteams: ["virtual ", "teams"],
  pcm: ["p", "c", "m"],
  ccp: ["p", "c", "m"],
  nist: ["n", "i", "s", "t ", "cert ", "reviews"],
  faqs: ["f", "a", "qs"],
  assurancemaintenance: ["assurance ", "maintenance"],
  niap: ["n", "i", "a", "p"],
  "ecr-comments": ["e", "c", "r ", "comments"],
};

const transformDashes = (name: string): string => {
  const spitName = name.split("-");
  const newName = capitalizeArray(spitName, " ");
  return newName;
};

const capitalizeArray = (
  input: Array<string>,
  delimiter: string = "",
): string => {
  const output = input.map((current) => capitalize(current));
  return output.join(delimiter);
};

const transformNumbers = (id: string): string => {
  return `ID: ${id}`;
};

const constructName = (name: string): string => {
  if (transformName.includes(name)) return capitalizeArray(transforms[name]);
  else if (name.includes("-")) return transformDashes(name);
  else if (isIdLink(name)) return transformNumbers(name);
  else return capitalize(name);
};

const isPcmDetailsLink = (): boolean => {
  return (
    (getSplitPath().includes("pcm") || getSplitPath().includes("ccp")) &&
    getSplitPath().includes("details")
  );
};

const isIdLink = (name: string): boolean => {
  return !isNaN(Number(name));
};

export const isPcmIdLink = (name: string): boolean => {
  return isPcmDetailsLink() && isIdLink(name);
};

export const displayHomeBreadcrumb = (index: number): boolean => {
  return index === 0;
};

export const validBreadcrumb = (index: number): boolean => {
  return !(
    getSplitPath()[index] === "" || getSplitPath()[index - 1] === "eventlog"
  );
};

export const displayEcrBreadcrumb = (): boolean => {
  return (
    getSplitPath().includes("ecr-comments") &&
    getSplitPath().includes("details")
  );
};

export const breadcrumbIsLink = (index: number): boolean => {
  if (
    getSplitPath()[index] === "protection-profile" ||
    getSplitPath()[index] === "assurancemaintenance" ||
    getSplitPath()[index] === "details" ||
    getSplitPath()[index] === "eventlog" ||
    index === getSplitPath().length - 1 ||
    (getSplitPath().includes("files") && index === getSplitPath().length - 2) ||
    (getSplitPath().includes("ecr-comments") &&
      index === getSplitPath().length - 2)
  )
    return false;
  else return true;
};

export const getBreadURL = (index: number): string => {
  const returnSplitPath = getSplitPath().slice(0, index + 1);
  return returnSplitPath.join("/");
};

export const getPcmNumber = async (
  name: string,
  action: (_args: ActionParams) => any,
) => {
  const id = Number(name);
  const pcmData = await action({
    rid: id,
  }).unwrap();
  setPcmNumber(pcmData.number);
};

export const displayName = (currentName: string): string => {
  if (isPcmIdLink(currentName)) {
    return `Ticket: ${pcmNumber}`;
  } else {
    return constructName(currentName);
  }
};

export const setCurrentPath = (pathname: string) => {
  currentPath = pathname;
};

export const getSplitPath = (): Array<string> => {
  return currentPath.split("/");
};

const setPcmNumber = (number: string) => {
  pcmNumber = number;
};
